import { render, staticRenderFns } from "./VerifiedInputTel.vue?vue&type=template&id=95138318&scoped=true"
import script from "./VerifiedInputTel.vue?vue&type=script&lang=js"
export * from "./VerifiedInputTel.vue?vue&type=script&lang=js"
import style0 from "./VerifiedInputTel.vue?vue&type=style&index=0&id=95138318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95138318",
  null
  
)

export default component.exports